import initialState from "../../../store/initialState";
import {
  DEACTIVATE_SERVICE_REQUEST_ERROR,
  DEACTIVATE_SERVICE_REQUEST_STARTING,
  DEACTIVATE_SERVICE_REQUEST_SUCCESS,
} from "../../../constants/actionTypes";
import { cloneDeep } from "lodash";

export default function deactivateServiceRequestReducer(
  state = initialState.deactivateServiceRequest,
  action
) {
  switch (action.type) {
    case DEACTIVATE_SERVICE_REQUEST_STARTING: {
      const { serviceId } = action;
      const newState = cloneDeep(state);

      if (!newState[serviceId]) {
        newState[serviceId] = cloneDeep(
          initialState.deactivateServiceRequest.serviceRequestId
        );
      }

      const updateData = newState[serviceId];
      updateData.saving = true;
      updateData.saved = false;
      updateData.error = null;

      return newState;
    }

    case DEACTIVATE_SERVICE_REQUEST_SUCCESS: {
      const { serviceId } = action;
      const newState = cloneDeep(state);

      if (!newState[serviceId]) {
        newState[serviceId] = cloneDeep(
          initialState.deactivateServiceRequest.serviceRequestId
        );
      }

      const updateData = newState[serviceId];
      updateData.saving = false;
      updateData.saved = true;
      updateData.error = null;
      return newState;
    }

    case DEACTIVATE_SERVICE_REQUEST_ERROR: {
      const { serviceId } = action;
      const newState = cloneDeep(state);

      if (!newState[serviceId]) {
        newState[serviceId] = cloneDeep(
          initialState.deactivateServiceRequest.serviceRequestId
        );
      }

      const updateData = newState[serviceId];
      updateData.saving = false;
      updateData.saved = false;
      updateData.error = action.err;
      return newState;
    }
    default: {
      return state;
    }
  }
}
